<template>
  <div class="detialBox mt-h">
    <div class="detial container">
      <div class="pagenav py-1">
        <span class="go_home" @click="goHomeFn">Home</span> >
        {{ detailsInfo.postTitle }}
      </div>
      <!-- banner -->
      <div class="detial-banner" v-show="detailsInfo">
        <img
          v-if="detailsInfo.type == '图片'"
          :src="detailsInfo.imgUrl"
          alt
          width="100%"
        />
        <!-- <video v-if="detailsInfo.type =='视频'" :src="detailsInfo.sourceUrl" width="100%" controls></video> -->
        <div
          v-show="detailsInfo.type == '视频' || detailsInfo.type == '直播'"
          id="player_box"
        ></div>
      </div>

      <!-- iconGroup -->
      <DetialIcon
        v-if="detailsInfo"
        :detailData="detailsInfo"
        @showWxFn="isShowWx = true"
        @showDialogFn="hbDialog = true"
      ></DetialIcon>

      <!-- 文章区域 -->
      <Artical :detailData="detailsInfo"></Artical>

      <!-- <div class="p-1">
        <img src="@/assets/imgs/detial/item.png" alt width="100%" />
      </div>-->

      <div class="related">
        <div class="article-btn">RELATED ARTICLES</div>
      </div>
      <!--  article-list -->
      <ArticleList :artilcleList="artilcleList"></ArticleList>

      <!-- loadmore -->
      <div class="w-100 morebox py-2">
        <div class="loadmore" @click="loadMoreFn">
          <span class="loadmore-txt pr-1">Load more</span>
          <b-icon icon="chevron-down"></b-icon>
        </div>
        <BackTop class="phoneback"></BackTop>
      </div>
    </div>
    <Footer></Footer>
    <div
      class="model_box"
      :class="{ post_model: showModel }"
      v-if="isShowModel && artilcleList.length > 0"
    >
      <div class="top_title">
        <i class="el-icon-close" @click="isShowModel = false"></i>
        <span class="tit_txt">MORE STORIES</span>
      </div>
      <div class="img_box" @click="gotoDetail(artilcleList[0]['postId'])">
        <img :src="setImgFn(artilcleList[0]['sourceUrl'])" alt="" />
      </div>
      <div class="dec_txt" @click="gotoDetail(artilcleList[0]['postId'])">
        {{ artilcleList[0]["postTitle"] }}
      </div>
    </div>
    <div class="imgDialog" v-if="hbDialog">
      <div class="img_box">
        <img
          class="close_img"
          @click="hbDialog = false"
          src="@/assets/imgs/detial/close_icon.png"
          alt=""
        />
        <img class="hb_img" :src="postImg" alt="" />
      </div>
    </div>
    <div class="weixin_box" v-if="isShowWx" @click="isShowWx = false">
      <img
        class="hint_img"
        src="https://www.shanghaieye.cn/wp-content/plugins/asian-social-share/images/wechat.jpg"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import DetialIcon from "./detialchild/DetialIconGroup.vue";
import Artical from "./detialchild/Artical.vue";
import ArticleList from "./detialchild/ArticleList.vue";

import Footer from "@/components/common/layout/Footer.vue";
import BackTop from "@/components/common/backtop/BackTop.vue";
import {
  getPreviewDetails,
  getPreview,
  getMoreData,
  getPosterImg,
  getPlayurl,
  setlike,
  getPreviewPoster,
} from "@/network/details.js";
import { setTimeout } from "timers";

export default {
  name: "MobileDetail",
  components: {
    DetialIcon,
    Artical,
    ArticleList,
    Footer,
    BackTop,
  },
  data() {
    return {
      postId: "",
      detailsInfo: "",
      artilcleList: [],
      indexNub: 3,
      viewData: [],
      realArr: "",
      aaa: "",
      showModel: false,
      page: 1,
      isShowModel: true,
      postImg: "",
      hbDialog: false,
      isShowWx: false,
      source: "",
      isLive: false,
      prePostId: "",
    };
  },
  created() {
    // this.getSendData();
  },
  computed: {
    setImgFn() {
      return function(url) {
        let index = url.lastIndexOf(".");
        let tempUrl = url.slice(0, index) + "_related" + url.slice(index);
        return tempUrl;
      };
    },
  },
  mounted() {
    this.postId = this.$route.query.prepostId;
    // console.log(this.postId,'this.postId')
    this.getDetailFn();
    window.addEventListener("scroll", this.handleScroll);
    this.getArticel();
    this.getPosterImgFn();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    goHomeFn() {
      this.$router.push("/home").catch((err) => {
        err;
      });
    },
    getPlayurlFn(vid) {
      getPlayurl({ videoId: vid }).then((res) => {
        if (res.code == 200) {
          this.source = res.data.playURL;
          this.initAly();
        }
      });
    },
    initAly() {
      var alplayer = new Aliplayer(
        {
          id: "player_box",
          source: this.source,
          // playauth : '',
          // vid:'2a43e5f70f094afb9c0c5962827f00d3',
          // http://cdn.img.mtedu.com/images/assignment/day_3.jpg
          cover: "", //播放器封面图
          width: "100%",
          // height: "300px",
          autoplay: true,
          isLive: this.isLive,
          rePlay: false,
          playsinline: true,
          preload: true,
          controlBarVisibility: "hover",
          useH5Prism: true,
        },
        function(player) {
          console.log("The player is created");
        }
      );
    },

    // previewPostId
    getPosterImgFn() {
      getPreviewPoster({ previewPostId: this.postId }).then((res) => {
        this.postImg = res.data;
      });
    },
    gotoDetail(id) {
      this.$router.push({
        path: "/detail",
        query: {
          postId: id,
        },
      });
    },
    handleScroll() {
      if (document.documentElement.scrollTop > 100) {
        this.showModel = true;
      } else {
        this.showModel = false;
      }
      // console.log(document.documentElement.scrollTop);
    },
    getPreviewData() {
      var review_id = localStorage.getItem("review_id");
      if (review_id) {
        getPreview({ previewPostId: review_id }).then((res) => {
          if (res.code == 200) {
            this.$nextTick(() => {
              this.detailsInfo = res.data;
              if (res.data.type == "视频") {
                if (
                  this.detailsInfo.sourceUrl != null &&
                  this.detailsInfo.sourceUrl
                ) {
                  if (this.detailsInfo.sourceUrl.indexOf("http") > -1) {
                    this.source = this.detailsInfo.sourceUrl;
                    this.initAly();
                  } else {
                    this.getPlayurlFn(this.detailsInfo.sourceUrl);
                  }
                }
              }
              if (this.detailsInfo.type == "直播") {
                this.isLive = true;
                this.source = this.detailsInfo.sourceUrl;
                this.initAly();
              }
            });
          }
          // console.log(this.detailsInfo, "detailsInfo");
        });
      }
    },
    getSendData() {
      let self = this;
      this.$nextTick(() => {
        window.addEventListener(
          "message",
          function(event) {
            if (event.data.previewPostId) {
              this.realArr = event.data.previewPostId;
              let idx = {};
              idx.previewPostId = this.realArr;
              localStorage.setItem("review_id", this.realArr);
              self.getPreviewData();
            }
          },
          false
        );
      });
    },
    loadMoreFn() {
      this.page++;
      this.getArticel();
      // this.indexNub = this.indexNub + 3;
    },
    getArticel() {
      getMoreData({ page: this.page, size: 3, postId: this.postId }).then(
        (res) => {
          this.artilcleList = this.artilcleList.concat(res.data);
        }
      );
    },

    getDetailFn() {
      this.prePostId = this.postId;

      getPreviewDetails({ prePostId: this.prePostId }).then((res) => {
        if (res.code == 200) {
          this.detailsInfo = res.data;
          document.title = res.data.postTitle + " | ShanghaiEye";
          if (
            this.detailsInfo.sourceUrl != null &&
            this.detailsInfo.sourceUrl &&
            this.detailsInfo.type == "视频"
          ) {
            if (this.detailsInfo.sourceUrl.indexOf("http") > -1) {
              this.source = this.detailsInfo.videoUrl;
              this.initAly();
            } else {
              this.getPlayurlFn(this.detailsInfo.videoUrl);
            }
          }
          if (this.detailsInfo.type == "直播") {
            this.isLive = true;
            this.source = this.detailsInfo.videoUrl;
            this.initAly();
          }
          // this.artilcleList = res.data.articles;
        }
      });
    },
  },
  watch: {
    $route(to, from) {
      this.$router.go(0);
    },
  },
};
</script>

<style lang="less">
.detialBox {
  .prism-player .prism-ErrorMessage .prism-error-operation a {
    font-size: 16px;
  }
  img {
    // width: 100%;
    height: auto;
  }
  .pcback,
  .phoneback {
    display: none;
  }
  .pagenav {
    color: #c3c3c3;
    font-size: 16px;
    font-family: Open Sans;
    .go_home {
      cursor: pointer;
      &:hover {
        color: #666;
      }
    }
  }
  .detial {
    .related {
      // margin-bottom: 10px;
      height: 0.9rem;
      font-size: 16px;
      // font-family: Calibri;
      // width: calc(100% - 0.5rem);
      margin-bottom: 10px;
      border-bottom: 2px solid #53a1dc;
      .article-btn {
        background: #53a1dc;
        height: 0.9rem;
        line-height: 0.9rem;
        width: 4rem;
        text-align: center;
        color: #ffffff;
      }
    }
    .morebox {
      clear: both;
      width: 100%;
    }
    .loadmore {
      // border-radius: 5px;
      font-size: 0.35rem;
      color: #929292;
      font-family: FranklinGothic-Demi;
      font-weight: bold;
      cursor: pointer;
      line-height: 0.3rem;
      // margin: 0.4rem auto;
      display: block;
      margin: 0 auto;
      width: 3rem;
      line-height: 0.7rem;
      text-align: center;
      border: 1px solid #ccc;
      padding: 0.1rem;
    }
  }
  .model_box {
    position: fixed;
    right: -345px;
    bottom: 120px;
    border: 1px solid #ededed;
    width: 340px;
    background-color: #fff;
    padding: 20px;
    z-index: 100;
    transition: all 0.5s cubic-bezier(0.265, 0.365, 0.26, 0.865);
    &.post_model {
      right: 0;
    }
    .top_title {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      i {
        font-size: 18px;
        padding: 0 8px;
        font-weight: bold;
        cursor: pointer;
      }
      .tit_txt {
        flex: 1;
        font-family: "Open Sans", arial, sans-serif;
        color: #222;
        font-size: 17px;
        font-weight: 600;
        line-height: 30px;
        display: inline-block;
        text-align: center;
      }
    }
    .img_box {
      width: 100%;
      height: 150px;
      margin-bottom: 10px;
      cursor: pointer;
      overflow: hidden;
      img {
        width: 100%;
        // height: 100%;
      }
    }
    .dec_txt {
      font-size: 16px;
      line-height: 22px;
      cursor: pointer;
      &:hover {
        color: #4db2ec;
      }
    }
  }
  .imgDialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #eaeaea;
    z-index: 6666;
    // display: flex;
    // align-content: center;
    // justify-content: center;
    .img_box {
      width: 90%;
      height: 100%;
      margin: 0 auto;
      position: relative;
      .close_img {
        width: 36px;
        height: 36px;
        position: absolute;
        right: -14px;
        top: -16px;
        z-index: 6666;
      }
      .hb_img {
        width: 100%;
        display: block;
        margin-top: 22px;
      }
    }
  }
  .weixin_box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 6666;
    .hint_img {
      // width: 100%;
      // max-width:400px;
      height: 100vh;
      margin: 0 auto;
      display: block;
    }
  }
}

@media screen and (min-width: 768px) {
  .detialBox {
    .imgDialog {
      display: none;
    }
    #player_box {
      height: 400px !important;
    }
    .pcback {
      display: block;
    }
    .loadmore {
      border-radius: 5px;
      font-size: 0.3rem;
      color: #929292;
      font-family: FranklinGothic-Demi;
      font-weight: bold;
      cursor: pointer;
      line-height: 0.2rem !important;
      // margin: 0.4rem auto;
      display: block;
      margin: 0 auto;
      text-align: center;
      border: 1px solid #ccc;
      width: 2.6rem !important;
    }
  }
}
@media screen and (max-width: 768px) {
  .detialBox {
    .model_box {
      display: none;
    }
    .container {
      margin: 0 auto !important;
    }
    #player_box {
      height: 300px;
    }
    .morebox {
      position: relative;
    }
    .phoneback {
      position: absolute;
      display: block;
      transform: translate(0, 50%);
    }
    .container {
      width: 100% !important;
      padding: 0;
      margin: 0;
      // margin-top: 1.3rem;
    }
    .pagenav {
      display: none;
      padding-top: 0;
    }
    .related {
      margin-bottom: 10px !important;
      margin-left: 0.5rem;
      margin-right: 0.5rem;
    }
  }
}
</style>
